import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import "./BatchWarningDialog.scss";

const BatchWarningDialog = ({
  open,
  onClose,
  message,
  title = "Batch Warning",
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      className="batch-warning-dialog"
      fullWidth
      maxWidth="sm"
      sx={{ zIndex: 9999 }}
      PaperProps={{ className: "batch-warning-dialog__paper" }}
    >
      <DialogTitle className="batch-warning-dialog__title">
        <Box className="batch-warning-dialog__icon-wrap">
          <WarningAmberRoundedIcon className="batch-warning-dialog__icon" />
        </Box>
        <Typography variant="h6" className="batch-warning-dialog__heading">
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent className="batch-warning-dialog__content">
        <DialogContentText component="div">
          <p className="batch-warning-dialog__message">{message}</p>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default BatchWarningDialog;
